import React, { useRef } from 'react'
import './ContactForm.css'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import emailjs from 'emailjs-com'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  name: {
    '& > *': {
      marginBottom: theme.spacing(2),
      backgroundColor: '#3b4353',
      color: 'white',
      '&:hover': {
        backgroundColor: '#3b4353',
        color: 'white',
      },
      '&.Mui-focused': {
        backgroundColor: '#3b4353',
        color: 'white',
      },
      '&.MuiFilledInput-underline:before': {
        borderBottom: '2px solid #6f7b9b',
      },
      '&.MuiFilledInput-underline:after': {
        borderBottom: '2px solid #258b9e',
      },
    },
  },

  email: {
    '& > *': {
      marginBottom: theme.spacing(2),
      backgroundColor: '#3b4353',
      color: 'white',
      '&:hover': {
        backgroundColor: '#3b4353',
        color: 'white',
      },
      '&.Mui-focused': {
        backgroundColor: '#3b4353',
        color: 'white',
      },
      '&.MuiFilledInput-underline:before': {
        borderBottom: '2px solid #6f7b9b',
      },
      '&.MuiFilledInput-underline:after': {
        borderBottom: '2px solid #258b9e',
      },
    },
  },
  message: {
    '& > *': {
      marginBottom: theme.spacing(2),
      backgroundColor: '#3b4353',
      color: 'white',
      '&:hover': {
        backgroundColor: '#3b4353',
        color: 'white',
      },
      '&.Mui-focused': {
        backgroundColor: '#3b4353',
        color: 'white',
      },
      '&.MuiFilledInput-underline:before': {
        borderBottom: '2px solid #6f7b9b',
      },
      '&.MuiFilledInput-underline:after': {
        borderBottom: '2px solid #258b9e',
      },
    },
  },
  submit: {
    '&': {
      backgroundColor: '#39b175',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: '#6de9ab',
        boxShadow: 'none',
      },
    },
    '& > *': {
      color: 'white',
      fontSize: '15px',
      fontWeight: '600',
    },
  },
}))

const ContactForm = () => {
  const form = useRef()
  const classes = useStyles()

  const sendEmail = (e) => {
    e.preventDefault()

    emailjs
      .sendForm(
        'service_ym1g3mt',
        'template_2h44t6v',
        e.target,
        '77F-u2p6bOJe1C-3G'
      )
      .then(
        (result) => {
          alert('Message Sent Successfully.')
        },
        (error) => {
          console.err(error.text)
        }
      )
    e.target.reset()
  }

  return (
    <div className="contact-form-wrapper">
      <form className="contact-form" onSubmit={sendEmail} method="POST">
        <TextField
          className={classes.name}
          type="name"
          name="name"
          label="Name"
          variant="filled"
          required
        />
        <TextField
          className={classes.email}
          type="email"
          name="email"
          label="Email"
          variant="filled"
          required
        />
        <TextField
          className={classes.message}
          type="text"
          name="message"
          label="Message"
          multiline
          rows="5"
          variant="filled"
        />
        <Button className={classes.submit} type="submit" variant="contained">
          Submit
        </Button>
      </form>
    </div>
  )
}

export default ContactForm
